import { useState } from "react";
import "./index.css";
import NoTransactionSelected from "../InitailStatesStores/NoTransactionSelected";
import { useEffect } from "react";
import { uiAlert } from "../alerts/customAlert/uiAlert";
import { useSelector } from "react-redux";
import { DeleteIcon } from "lucide-react";

const ReceiptComponent = ({ product, setDiscount, sellingCart, currency, vatRate, setVatRate, vatAmount }) => {
  const { store } = useSelector((state) => state.store);
  const [showDiscountOverlay, setShowDiscountOverlay] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [tempDiscountAmount, setTempDiscountAmount] = useState("");
  console.log(vatAmount, vatRate, "vatAmount, vatRate in receipt component");

  useEffect(() => {
    // Reset discount amount when sellingCart changes
    if (sellingCart.length === 0) {
      setDiscountAmount(0);
      setTempDiscountAmount("");
      setDiscount(0);
    }
  }, [sellingCart]);

  const subtotal = sellingCart.reduce((acc, item) => acc + item.soldUnitPrice * item.soldQuantity, 0);
  const total = Math.ceil(Number(subtotal) + Number(vatAmount) - discountAmount);

  const handleAddDiscount = () => {
    if (sellingCart.length === 0) {
      uiAlert("Please add items to the cart before applying a discount.");
      return;
    } // Prevent discount overlay if no items in cart
    setShowDiscountOverlay(true);
    setTempDiscountAmount(discountAmount.toString());
  };

  const handleApplyDiscount = () => {
    const amount = parseFloat(tempDiscountAmount) || 0;
    if (amount < 0 || amount > subtotal || amount === 0) {
      uiAlert(`Please enter a valid discount amount between ${1} and ${subtotal.toFixed(2)}.`, "error");
      return;
    }
    setDiscountAmount(amount);
    setShowDiscountOverlay(false);
    setDiscount(amount);
  };

  const handleCancelDiscount = () => {
    setShowDiscountOverlay(false);
    setTempDiscountAmount("");
  };

  const HandleclearDiscount = () => {
    setDiscountAmount(0);
    setTempDiscountAmount("");
    setDiscount(0);
  };
  return (
    <>
      <div className='receipt-container'>
        {/* Order items */}
        <div className='receipt-items'>
          {sellingCart.length > 0 ? (
            sellingCart.map((item) => (
              <div key={item._id} className='receipt-item'>
                <div className='item-details'>
                  <span className='item-quantity'>{item.soldQuantity}x</span>
                  <div className='item-info'>
                    <div className='item-name'>{item.name}</div>
                    {item.brand && <div className='item-description'>{item.brand}</div>}
                  </div>
                </div>
                <div className='item-price'>
                  {currency}
                  {(Number(item?.soldUnitPrice) * Number(item.soldQuantity))?.toLocaleString()}
                </div>
              </div>
            ))
          ) : (
            <div style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "center", alignItems: "center" }}>
              {" "}
              <h3
                style={{
                  color: "rgb(99, 99, 99)",
                }}
              >
                Your Selling Cart is Empty
              </h3>
              <p
                style={{
                  marginTop: "10px",
                  fontSize: "14px",
                  textAlign: "center",
                  color: "rgb(99, 99, 99)",
                }}
              >
                Please select products to add to your selling cart.
              </p>
            </div>
          )}
        </div>

        {/* Totals section */}
        <div className='receipt-totals'>
          <div
            style={{
              marginBottom: "0",
            }}
            className='total-line'
          >
            <span className='total-label2'>Subtotal</span>
            <span className='total-amount2'>
              {currency}
              {subtotal.toLocaleString()}
            </span>
          </div>
          {store.isVATenabled ? (
            <div className='total-line'>
              <span
                style={{
                  fontSize: "14px",
                  position: "relative",
                }}
                className='total-label2'
              >
                <span
                  onClick={() => {
                    setVatRate(0);
                  }}
                  className='clearDistcount'
                  style={{
                    display: vatRate > 0 ? "flex" : "none",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <DeleteIcon size={14} />
                </span>
                VAT
                <input
                  value={vatRate}
                  inputMode='decimal'
                  onChange={(e) => {
                    const value = Number(e.target.value);

                    if (Number.isNaN(value)) {
                      setVatRate(0);
                      return;
                    }

                    setVatRate(Math.min(100, Math.max(0, value)));
                  }}
                  style={{
                    width: "40px",
                    height: "30px",
                    marginLeft: "5px",
                    fontSize: "14px",
                    textAlign: "center",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  type='number'
                  min='0'
                  max='100'
                  step='0.01'
                />
                %
              </span>
              <span
                style={{
                  fontSize: "14px",
                }}
                className='total-amount2'
              >
                {currency}
                {((subtotal * vatRate) / 100).toLocaleString()}
              </span>
            </div>
          ) : (
            <div className='total-line'>
              <span>VAT is excluded</span>
            </div>
          )}
          <div className='total-line discount'>
            <span
              style={{
                fontSize: "16px",
                color: "#8f6f18",
              }}
              className='total-label'
            >
              Discount
            </span>
            {discountAmount > 0 ? (
              <>
                <span
                  style={{
                    fontSize: "16px",
                    color: "#8f6f18",
                  }}
                  className='total-amount2'
                >
                  -{currency}
                  {discountAmount.toLocaleString()}
                </span>

                <span onClick={HandleclearDiscount} className='clearDistcount'>
                  Clear
                </span>
              </>
            ) : (
              <button className='discount-btn' onClick={handleAddDiscount}>
                <span className='discount-icon'>+</span>
                Add Discount
              </button>
            )}
          </div>
          <div className='total-line final-total'>
            <span className='total-label'>Total</span>
            <span className='total-amount2'>
              {currency}
              {total.toLocaleString()}
            </span>
          </div>
        </div>
      </div>

      {/* Discount Overlay */}
      {showDiscountOverlay && (
        <div onClick={handleCancelDiscount} className='discount-overlay'>
          <div onClick={(e) => e.stopPropagation()} className='discount-modal'>
            <h3 className='discount-title'>Add Discount</h3>
            <div className='discount-input-group'>
              <label className='discount-label'>Discount Amount ({currency})</label>
              <input
                type='number'
                value={tempDiscountAmount}
                onChange={(e) => setTempDiscountAmount(e.target.value)}
                placeholder='0.00'
                className='discount-input'
                step='0.01'
                min='0'
                max={subtotal}
              />
            </div>
            <div className='discount-actions'>
              <button className='discount-cancel-btn' onClick={handleCancelDiscount}>
                Cancel
              </button>
              <button className='discount-apply-btn' onClick={handleApplyDiscount}>
                Apply Discount
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReceiptComponent;
